<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检点名称" prop="pointName">
              <a-input placeholder="请输入巡检点名称" v-model="model.pointName"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区域" prop="devProcessId">
              <j-dict-select-tag
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择区域"
                v-model="model.devProcessId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="编号" prop="pointCode">
              <a-input placeholder="请输入编号" v-model="model.pointCode"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="描述" prop="pointDesc">
              <a-textarea placeholder="请输入描述" rows="4" v-model="model.pointDesc" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs @change="handleChangeTabs" v-model="activeKey">
      <a-tab-pane :forceRender="true" :key="refKeys[0]" tab="巡检点设备">
        <!-- <div class="table-operator">
          <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
        </div>-->
        <j-editable-table
          :alwaysEdit="false"
          :columns="ywArtificialPatrolPointDevTable.columns"
          :dataSource="ywArtificialPatrolPointDevTable.dataSource"
          :disabled="formDisabled"
          :loading="ywArtificialPatrolPointDevTable.loading"
          :maxHeight="300"
          :ref="refKeys[0]"
          :rowNumber="true"
          :rowSelection="true"
        >
          <!--  :actionButton="true" -->
          <template v-slot:buttonBefore="props">
            <a-button @click="handleAdd()" icon="plus" type="primary">新增</a-button>
            <a-button @click="handleDelete(props)" class="ml-10px">删除</a-button>
          </template>
          <!-- <template v-slot:action="props">
            <a @click="handleDelete(props)">新增</a>
          </template>-->
        </j-editable-table>
      </a-tab-pane>
    </a-tabs>
    <j-select-device-by-process-modal :modal-width="1200" :multi="true" @ok="selectOK" ref="selectDevModal" />
  </a-spin>
</template>

<script>
  import { getAction } from '@/api/manage'
  import { FormTypes, getRefPromise, VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'
  import { validateDuplicateValue } from '@/utils/util'
  import JSelectDeviceByProcessModal from '@/components/jeecgbiz/modal/JSelectDeviceByProcessModal'

  export default {
    name: 'YwArtificialPatrolPointForm',
    mixins: [JEditableTableModelMixin],
    components: {
      JSelectDeviceByProcessModal
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 }
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 }
        },
        model: {},
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          pointName: [{ required: true, message: '请输入巡检点名称!' }]
        },
        refKeys: ['ywArtificialPatrolPointDev'],
        tableKeys: ['ywArtificialPatrolPointDev'],
        activeKey: 'ywArtificialPatrolPointDev',
        // 巡检点设备
        ywArtificialPatrolPointDevTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '设备ID',
              key: 'devId',
              type: FormTypes.input,
              width: '40%',
              placeholder: '请输入${title}',
              defaultValue: '',
              disabled: true,
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            {
              title: '设备',
              key: 'devName',
              type: FormTypes.input,
              width: '50%',
              placeholder: '请输入${title}',
              defaultValue: '',
              disabled: true,
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            {
              title: '排序',
              key: 'orderNo',
              type: FormTypes.inputNumber,
              width: '10%',
              placeholder: '请输入${title}',
              defaultValue: ''
            }
          ]
        },
        url: {
          add: '/device/patrol/ywArtificialPatrolPoint/add',
          edit: '/device/patrol/ywArtificialPatrolPoint/edit',
          queryById: '/device/patrol/ywArtificialPatrolPoint/queryById',
          ywArtificialPatrolPointDev: {
            list: '/device/patrol/ywArtificialPatrolPoint/queryYwArtificialPatrolPointDevByMainId'
          }
        }
      }
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () { },
    methods: {
      addBefore () {
        this.ywArtificialPatrolPointDevTable.dataSource = []
      },
      getAllTable () {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter () {
        this.$nextTick(() => { })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.ywArtificialPatrolPointDev.list, params, this.ywArtificialPatrolPointDevTable)
        }
      },
      //校验所有一对一子表表单
      validateSubForm (allValues) {
        return new Promise((resolve, reject) => {
          Promise.all([])
            .then(() => {
              resolve(allValues)
            })
            .catch(e => {
              if (e.error === VALIDATE_NO_PASSED) {
                // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
                this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
              } else {
                console.error(e)
              }
            })
        })
      },
      /** 整理成formData */
      classifyIntoFormData (allValues) {
        let main = Object.assign(this.model, allValues.formValue, {
          devCount: this.ywArtificialPatrolPointDevTable.dataSource.length
        })
        return {
          ...main, // 展开
          ywArtificialPatrolPointDevList: allValues.tablesValue[0].values
        }
      },
      validateError (msg) {
        this.$message.error(msg)
      },
      handleAdd () {
        this.$refs.selectDevModal.showModal()
      },
      handleDelete (props) {
        let { rowId, target } = props
        target.removeSelectedRows()
      },
      selectOK (rows) {
        if (rows.length > 0) {
          const devIdArr = this.ywArtificialPatrolPointDevTable.dataSource.map(row => row.id)
          rows.forEach(dev => {
            if (!devIdArr.includes(dev.id)) {
              this.ywArtificialPatrolPointDevTable.dataSource.push({
                devId: dev.id,
                devName: dev.devName,
                orderNo: this.ywArtificialPatrolPointDevTable.dataSource.length + 1
              })
            }
          })
        }
      }
    }
  }
</script>

<style scoped></style>
